var exports = {
  "V": "x31de4314--ca4d79--preview",
};

module.exports = exports;
